import * as Sentry from '@sentry/react';

// GDPR: Sentry session replay buffers a recording of the page (text and media masked) to send with
// an error, so it only runs after the visitor accepts the cookie banner. Plain error capture does
// not depend on consent and is set up in src/index.tsx.

let isReplayActive = false;

/** Starts error-replay buffering. Safe to call repeatedly; a no-op when Sentry is not initialised. */
export function enableSentryReplay(): void {
  if (isReplayActive || !Sentry.isInitialized()) {
    return;
  }

  const replay = Sentry.getReplay();

  if (replay) {
    replay.startBuffering();
  } else {
    Sentry.addIntegration(Sentry.replayIntegration({ maskAllText: true, blockAllMedia: true }));
  }

  isReplayActive = true;
}

/** Stops replay, e.g. when consent is withdrawn. Safe to call when replay never started. */
export function disableSentryReplay(): void {
  if (!isReplayActive) {
    return;
  }

  void Sentry.getReplay()?.stop();
  isReplayActive = false;
}

/** Test seam: forget whether replay was started. */
export function resetSentryReplayForTests(): void {
  isReplayActive = false;
}
